import { FieldBase } from '../fields/field-base';
import { UntypedFormGroup } from '@angular/forms';

export class DropDownFormSectionData {
  prepopulatedData: any;
  startOpen: boolean;
  parentForm: UntypedFormGroup;
  displayAutoTitle: boolean;
  titleText: string;
  displayAutoDescription: boolean;
  descriptionText: string;
  fields: FieldBase<any>[];
  editingHint: string;
  /* tslint:disable */
  expandable? = true;
  /* tslint:enable */
}
